module.exports = __webpack_public_path__ + "img/transformations-feature-1.d80ae722.svg";